import { useState } from 'react';
import { risingList } from '../data';

export default function RisingForecast() {
  const [seen, setSeen] = useState<string[]>([]);
  const toggle = (title: string) =>
    setSeen((s) => (s.includes(title) ? s.filter((x) => x !== title) : [...s, title]));

  return (
    <section id="rising" className="border-b border-foreground-900/10 bg-accent-950/[0.06]">
      <div className="mx-auto max-w-6xl px-4 py-8 md:px-6 md:py-12">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
          {/* 说明区 */}
          <div className="lg:col-span-4">
            <p className="kicker text-xs text-primary-600">升温预判 · NEXT WAVE</p>
            <h2 className="mt-2 font-heading text-2xl font-semibold tracking-tight text-foreground-950 md:text-3xl">
              下一波要涨的瓜料
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              基于转发结构、讨论增速与历史衰减模型，预判未来 24–48 小时可能继续升温的候选，提前锁定「下一波讨论浪潮」的起点。
            </p>
            <div className="mt-5 flex items-center gap-4 rounded-lg border border-foreground-900/10 bg-background-50 p-4 text-sm">
              <i className="ri-lightbulb-flash-line text-xl text-accent-600"></i>
              <p className="text-foreground-600">
                模型提示：当前升温最快的多是「可截图存证」类内容，二次传播力显著高于一次性新闻。
              </p>
            </div>
          </div>

          {/* 预测列表 */}
          <div className="lg:col-span-8">
            <div className="flex flex-col gap-3">
              {risingList.map((r, idx) => {
                const watched = seen.includes(r.title);
                return (
                  <button
                    key={r.title}
                    onClick={() => toggle(r.title)}
                    className={`flex flex-col gap-3 rounded-lg border bg-background-50 p-4 text-left transition-colors sm:flex-row sm:items-center ${
                      watched ? 'border-accent-500/40' : 'border-foreground-900/10'
                    }`}
                  >
                    <span
                      className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-full font-heading text-lg font-semibold ${
                        idx < 2 ? 'bg-primary-100 text-primary-800' : 'bg-secondary-100 text-secondary-700'
                      }`}
                    >
                      {idx + 1}
                    </span>
                    <div className="min-w-0 flex-1">
                      <div className="flex flex-wrap items-center gap-2">
                        <h3 className="text-[15px] font-medium text-foreground-900">{r.title}</h3>
                        {watched && (
                          <span className="rounded-full bg-accent-100 px-2 py-0.5 text-[11px] text-accent-800">已盯盘</span>
                        )}
                      </div>
                      <p className="mt-1 text-xs text-foreground-500">{r.note}</p>
                    </div>
                    <div className="flex shrink-0 items-center gap-4 text-right">
                      <div className="hidden sm:block">
                        <p className="text-[11px] text-foreground-400">{r.base}</p>
                        <p className="text-[11px] text-foreground-400">{r.target}</p>
                      </div>
                      <div className="w-24 shrink-0 rounded-md bg-secondary-100 px-2 py-1.5 text-center">
                        <p className="font-heading text-lg font-semibold text-primary-600">{r.percent}</p>
                        <p className="text-[11px] text-foreground-500">预计增幅</p>
                      </div>
                    </div>
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}